export const realEstateNavItems = {
  services: 'Services',

  landPlot: 'Land Plot',

};

export const realEstateSecondDescription =
  "Our goal is to help you find your dream home, whether you're looking to buy or rent. We offer a wide range of properties in different locations and styles, so you're sure to find something that suits your needs and budget. Take a look at our featured properties below or use the search bar to find a specific type of property or location. If you need any assistance or have questions, feel free to contact us.";
